exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vs-button[data-v-a0936776]{\n  -webkit-transition:all .2s ease;\n  transition:all .2s ease;\n  padding:10px;\n  border:0;\n  border-radius:6px;\n  border-top-left-radius:6px;\n  border-top-right-radius:6px;\n  border-bottom-right-radius:6px;\n  border-bottom-left-radius:6px;\n  cursor:pointer;\n  position:relative;\n  overflow:hidden;\n  color:#fff;\n  -webkit-box-sizing:border-box;\n  box-sizing:border-box;\n  background:rgba(0,0,0,0)\n}", ""]);

// exports
